import { render, staticRenderFns } from "./news_ticker.vue?vue&type=template&id=142ea820&"
import script from "./news_ticker.vue?vue&type=script&lang=js&"
export * from "./news_ticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports